module.exports = __webpack_public_path__ + "static/media/Nokia 220 Black.a435174a.png";